import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Truck } from "lucide-react";
import { wmsApi, fmtEur, fmtDate } from "./wmsApi";
import { WCard, WBadge } from "./WmsUi";

export default function WmsSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const [details, setDetails] = useState({});
  const [open, setOpen] = useState({});

  useEffect(() => { wmsApi.get("/wms/suppliers").then((r) => setSuppliers(r.data)).catch(() => {}); }, []);

  const toggle = async (sid) => {
    const willOpen = !open[sid];
    setOpen({ ...open, [sid]: willOpen });
    if (willOpen && !details[sid]) {
      try {
        const r = await wmsApi.get(`/wms/suppliers/${sid}`);
        setDetails((d) => ({ ...d, [sid]: r.data }));
      } catch { /* ignore */ }
    }
  };

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-['Chivo'] font-black text-3xl tracking-tighter uppercase">Fornitori</h1>
        <p className="text-zinc-500 mt-1">Anagrafica auto-appresa dai carichi: codici prodotto e ultimo prezzo d'acquisto</p>
      </div>
      <div className="space-y-2">
        {suppliers.map((s) => (
          <WCard key={s.id} className="border-2 border-zinc-300">
            <button className="w-full p-4 flex items-center gap-3 text-left" onClick={() => toggle(s.id)} data-testid={`supplier-row-${s.id}`}>
              <Truck className="w-6 h-6 text-[#FF4500] shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="font-bold truncate">{s.name}</p>
                <p className="text-xs text-zinc-500">{s.receipts_count || 0} carichi{s.last_receipt_at ? ` · ultimo ${fmtDate(s.last_receipt_at)}` : ""}</p>
              </div>
              {open[s.id] ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
            </button>
            {open[s.id] && (
              <div className="border-t border-zinc-200">
                {(details[s.id]?.products || []).length === 0 ? (
                  <p className="px-4 py-4 text-sm text-zinc-500">Nessun prodotto ancora appreso (i prodotti si salvano alla conferma del carico).</p>
                ) : (
                  <div className="divide-y divide-zinc-100">
                    {details[s.id].products.map((p) => (
                      <div key={p.id} className="px-4 py-2.5 flex items-center gap-3 text-sm flex-wrap" data-testid={`supplier-product-${p.product_code}`}>
                        <span className="font-mono text-xs text-zinc-400 w-28 shrink-0">{p.supplier_code || "—"}</span>
                        <span className="font-semibold flex-1 truncate">{p.product_name}</span>
                        <WBadge tone="dark">{p.category_name || "—"}</WBadge>
                        <span className="text-zinc-500 text-xs">×{p.times_used || 1} · {fmtDate(p.last_date)}</span>
                        <span className="font-['Chivo'] font-black">{p.last_price != null ? `${fmtEur(p.last_price)}/${p.last_um || "kg"}` : "—"}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </WCard>
        ))}
        {suppliers.length === 0 && <WCard className="p-8 text-center text-zinc-500" data-testid="suppliers-empty">Nessun fornitore: si popoleranno automaticamente con i carichi.</WCard>}
      </div>
    </div>
  );
}
